var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 11.513V14.2667C19.3337 14.6401 19.3337 14.8268 19.4063 14.9694C19.4702 15.0948 19.5722 15.1968 19.6977 15.2607C19.8403 15.3334 20.027 15.3334 20.4003 15.3334H23.154M23.3337 16.6589V21.4667C23.3337 22.5868 23.3337 23.1469 23.1157 23.5747C22.9239 23.951 22.618 24.257 22.2416 24.4487C21.8138 24.6667 21.2538 24.6667 20.1337 24.6667H15.867C14.7469 24.6667 14.1868 24.6667 13.759 24.4487C13.3827 24.257 13.0767 23.951 12.885 23.5747C12.667 23.1469 12.667 22.5868 12.667 21.4667V14.5334C12.667 13.4133 12.667 12.8532 12.885 12.4254C13.0767 12.0491 13.3827 11.7431 13.759 11.5514C14.1868 11.3334 14.7469 11.3334 15.867 11.3334H18.0082C18.4974 11.3334 18.7419 11.3334 18.9721 11.3886C19.1762 11.4376 19.3713 11.5184 19.5502 11.6281C19.7521 11.7518 19.925 11.9247 20.2709 12.2706L22.3964 14.3961C22.7423 14.742 22.9153 14.915 23.0389 15.1168C23.1486 15.2957 23.2294 15.4908 23.2784 15.6949C23.3337 15.9251 23.3337 16.1697 23.3337 16.6589Z",
    stroke: "#155EEF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#EFF4FF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile2);
export default __webpack_public_path__ + "static/media/file2.d51639b21963d4a015a935ea6c697979.svg";
export { ForwardRef as ReactComponent };